module.exports = __webpack_public_path__ + "static/img/40012 (2).8e7cae6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40012 (2).webp
// module id = v/nu
// module chunks = 14